import styled from '@emotion/styled';
import { ChatGreetingViewProps } from './types';
import { Button, Text } from '@innovationdepartment/proxima-ui';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 8px;
`;

const ChatGreetingNoIntegrationsConnected = (props: ChatGreetingViewProps) => {
  const { integrations } = props;
  return (
    <Container>
      <Text variant="h4" isTermina={false} color="neutral70">
        Connect an account to get started
      </Text>
      <ButtonsContainer>
        {integrations.map((integration) => {
          const { name, onConnect, type } = integration;

          return (
            <Button
              size="medium"
              key={name}
              onClick={() => onConnect(type)}
              label={`Connect ${name}`}
            />
          );
        })}
      </ButtonsContainer>
    </Container>
  );
};

export default ChatGreetingNoIntegrationsConnected;
